import FormField from './FormField';

// Stores value as decimal (0.25 = 25%) but displays/accepts as percentage (25)
export default function PercentageField({
  label,
  name,
  value,
  onChange,
  error,
  required,
  hint,
  placeholder = '0',
  min = 0,
  max = 100,
}) {
  const displayValue = value !== undefined && value !== null && value !== ''
    ? parseFloat((value * 100).toFixed(6))
    : '';

  function handleChange(e) {
    const raw = e.target.value;
    if (raw === '') {
      onChange({ target: { name, value: '' } });
      return;
    }
    const decimal = parseFloat(raw) / 100;
    onChange({ target: { name, value: decimal } });
  }

  return (
    <FormField label={label} required={required} error={error} hint={hint}>
      <div style={{ position: 'relative' }}>
        <input
          type="number"
          name={name}
          value={displayValue}
          onChange={handleChange}
          className={`form-input ${error ? 'error' : ''}`}
          placeholder={placeholder}
          min={min}
          max={max}
          step="0.01"
          style={{ paddingRight: 30 }}
        />
        <span style={{
          position: 'absolute', right: 10, top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--color-text-secondary)', fontSize: 14,
        }}>%</span>
      </div>
    </FormField>
  );
}
